import React, { useContext, useEffect, useRef } from 'react';
import type { NavigationBarProps } from '@oneaudi/unified-web-components';
import { NavigationBar } from '@oneaudi/unified-web-components';
import { UeContainer, UeElement, UeReference } from '@oneaudi/falcon-tools';
import { TRIGGERID } from '../../../ContentType';
import { useTrackingManager } from '../../../utils/useTrackingManager';
import { useBreakpoint } from '../../../utils/useBreakpoint';
import { useI18n } from '../../../i18n';
import { Context } from '../../../context/Context';
import { attachHorizontalNavigation } from '../../../utils/a11y';

export const PagesMenu = () => {
  const {
    content: { links },
    linkCount,
    ctaCount,
  } = useContext(Context);

  const navRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (navRef.current) {
      attachHorizontalNavigation(navRef.current);
    }
  }, []);

  const { click } = useTrackingManager();
  const { breakpoint } = useBreakpoint();
  const ariaSubmenu = useI18n('ariaSubmenu');
  const ariaScrollLeft = useI18n('ariaScrollLeft');
  const ariaScrollRight = useI18n('ariaScrollRight');

  const navItems: NavigationBarProps['items'] = links.map(
    ({ text, href, ariaLabel, opensInNewTab, currentPage }, i) => ({
      label: (
        <UeReference key={text} propertyPath={`links.${i}`} behavior="component">
          <UeElement type="text" label="Sub Pages">
            {text}
          </UeElement>
        </UeReference>
      ),
      href,
      target: opensInNewTab ? '_blank' : undefined,
      rel: opensInNewTab ? 'noopener noreferrer' : undefined,
      active: !!currentPage,
      icon: undefined,
      iconPosition: 'leading',
      onClick: () => {
        click('link', text, href, `${i + 1}`, breakpoint, '');
      },
      'aria-label': !currentPage && ariaLabel ? ariaLabel : undefined,
    }),
  );

  return (
    <UeContainer propertyPath="links" label="Sub Pages">
      <NavigationBar
        id="subMenuNavbar"
        scrollButtons={{
          left: {
            ariaLabel: ariaScrollLeft,
            onClick: () => {
              click('arrow', 'Left', '', '', breakpoint, '', linkCount, ctaCount);
            },
          },
          right: {
            ariaLabel: ariaScrollRight,
            onClick: () => {
              click('arrow', 'Right', '', '', breakpoint, '', linkCount, ctaCount);
            },
          },
        }}
        size="sm"
        items={navItems}
        className="subpage-navigation-bar"
        aria-label={ariaSubmenu}
        aria-labelledby={TRIGGERID.DESKTOP}
        ref={navRef}
      />
    </UeContainer>
  );
};
